import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { ConfidenceBadge, StatusPill } from "@/components/badges";
import StationPanel from "@/components/StationPanel";
import { ClipboardTextIcon, MapPinIcon, UserIcon } from "@phosphor-icons/react";

export default function Review() {
  const [items, setItems] = useState([]);
  const [sel, setSel] = useState(null);

  const load = () => api.get("/sites-pending").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  return (
    <div className="p-5 lg:p-8 space-y-5">
      <div>
        <h1 className="font-display text-2xl lg:text-3xl font-semibold text-slate-900">Pending Review</h1>
        <p className="text-sm text-slate-500 mt-1">Analyst-submitted stations awaiting admin approval before they are published.</p>
      </div>

      {items.length === 0 ? (
        <div className="rounded-xl border border-dashed border-slate-200 bg-white p-12 text-center">
          <ClipboardTextIcon size={32} className="mx-auto text-slate-300" />
          <p className="mt-2 text-sm text-slate-400">No stations awaiting review.</p>
        </div>
      ) : (
        <div className="grid gap-3 md:grid-cols-2">
          {items.map((s) => (
            <button key={s.id} data-testid={`review-${s.id}`} onClick={() => setSel(s.id)}
              className="rounded-xl border border-amber-200 bg-amber-50/40 p-4 text-left transition-colors hover:bg-amber-50">
              <div className="flex items-start justify-between gap-2">
                <div className="min-w-0">
                  <div className="font-medium text-slate-900">{s.name}</div>
                  <div className="text-xs text-slate-500 flex items-center gap-1 mt-0.5"><MapPinIcon size={12} /> {s.address || `${s.latitude?.toFixed(4)}, ${s.longitude?.toFixed(4)}`}</div>
                </div>
                <ConfidenceBadge label={s.confidence?.label} score={s.confidence?.overall_score} />
              </div>
              <div className="mt-3 flex flex-wrap items-center gap-2 text-xs text-slate-500">
                <StatusPill status={s.status} />
                <span className="rounded-full bg-white border border-slate-200 px-2 py-0.5">{s.access_type || "Public"}</span>
                {(s.photos || []).length > 0 && <span className="rounded-full bg-white border border-slate-200 px-2 py-0.5">{s.photos.length} photo(s)</span>}
                <span className="flex items-center gap-1"><UserIcon size={12} /> {s.added_by}</span>
              </div>
            </button>
          ))}
        </div>
      )}

      <StationPanel open={!!sel} mode="view" siteId={sel} onClose={() => setSel(null)} onSaved={() => { setSel(null); load(); }} />
    </div>
  );
}
